import React, { useEffect, useState } from 'react';
import api from '../api';

export default function WebhookDebug() {
  const [events, setEvents]   = useState([]);
  const [loading, setLoading] = useState(true);
  const [auto, setAuto]       = useState(true);

  async function fetchEvents() {
    try {
      const r = await api.get('/webhooks/debug');
      setEvents(r.data.events);
    } catch (e) {
      console.error(e);
    }
    setLoading(false);
  }

  useEffect(() => {
    fetchEvents();
  }, []);

  useEffect(() => {
    if (!auto) return;
    const id = setInterval(fetchEvents, 3000);
    return () => clearInterval(id);
  }, [auto]);

  const typeStyle = {
    status_update:    { background: 'rgba(34,197,94,0.15)',   color: '#22c55e',   label: '📊 Status Update' },
    incoming_message: { background: 'rgba(99,102,241,0.15)',  color: '#a5b4fc',   label: '💬 Incoming Msg'  },
    unmatched_phone:  { background: 'rgba(245,158,11,0.15)',  color: '#f59e0b',   label: '⚠️  No User Match' },
    error:            { background: 'rgba(239,68,68,0.15)',   color: '#ef4444',   label: '❌ Error'          },
  };

  return (
    <div>
      <div className="page-header">
        <h1 className="page-title">Webhook Debug</h1>
        <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
          <label style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 13, cursor: 'pointer' }}>
            <input type="checkbox" checked={auto} onChange={e => setAuto(e.target.checked)} />
            Auto-refresh every 3 s
          </label>
          <button className="btn btn-ghost btn-sm" onClick={fetchEvents}>↻ Refresh</button>
        </div>
      </div>

      {/* Checklist */}
      <div className="card" style={{ marginBottom: 20 }}>
        <div className="card-title">Setup checklist</div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8, fontSize: 13 }}>
          {[
            { label: 'ngrok is running (`ngrok http 5000`)', check: true },
            { label: 'Meta Dashboard → WhatsApp → Configuration → Callback URL ends with /api/webhooks/whatsapp', check: true },
            { label: 'Verify token matches WA_WEBHOOK_VERIFY_TOKEN in .env (default: my_verify_token)', check: true },
            { label: 'Webhook field "messages" is subscribed in Meta Dashboard', check: null },
            { label: 'Phone Number ID in Settings matches what Meta sends in webhook payloads', check: null },
          ].map((item, i) => (
            <div key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: 10 }}>
              <span style={{ fontSize: 16, flexShrink: 0 }}>
                {item.check === true ? '✅' : item.check === false ? '❌' : '⬜'}
              </span>
              <span style={{ color: 'var(--text-muted)' }}>{item.label}</span>
            </div>
          ))}
        </div>

        <div style={{ marginTop: 16, padding: 12, background: 'var(--surface2)', borderRadius: 8, fontSize: 12, lineHeight: 1.8 }}>
          <strong style={{ color: 'var(--primary-light)' }}>How to subscribe "messages" field in Meta:</strong><br />
          developers.facebook.com → Your App → WhatsApp → Configuration<br />
          → Scroll to <strong>Webhook fields</strong> → click <strong>Manage</strong><br />
          → Find <strong>messages</strong> → click <strong>Subscribe</strong>
        </div>
      </div>

      {/* Live events */}
      <div className="card">
        <div className="card-title">
          Live webhook events {auto && <span style={{ color: 'var(--success)', fontSize: 12, fontWeight: 400 }}>● live</span>}
        </div>

        {loading
          ? <div style={{ color: 'var(--text-muted)', padding: 24, textAlign: 'center' }}>Loading…</div>
          : events.length === 0
            ? (
              <div style={{ padding: 32, textAlign: 'center' }}>
                <div style={{ fontSize: 32, marginBottom: 12 }}>📭</div>
                <div style={{ color: 'var(--text-muted)', fontSize: 14 }}>No webhook events received yet.</div>
                <div style={{ color: 'var(--text-muted)', fontSize: 13, marginTop: 8 }}>
                  Send a broadcast, then open the WhatsApp message on your phone.<br />
                  Status updates should appear here within seconds.
                </div>
              </div>
            )
            : (
              <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                {events.map((ev, i) => {
                  const cfg = typeStyle[ev.type] || { background: 'var(--surface2)', color: 'var(--text)', label: ev.type };
                  return (
                    <div key={i} style={{ padding: '10px 14px', borderRadius: 8, background: cfg.background, border: `1px solid ${cfg.color}30` }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 4 }}>
                        <span style={{ fontWeight: 600, color: cfg.color, fontSize: 13 }}>{cfg.label}</span>
                        <span style={{ color: 'var(--text-muted)', fontSize: 11 }}>
                          {new Date(ev.ts).toLocaleTimeString()}
                        </span>
                      </div>
                      <pre style={{ fontSize: 12, color: 'var(--text-muted)', margin: 0, whiteSpace: 'pre-wrap', wordBreak: 'break-all' }}>
                        {JSON.stringify(ev.data, null, 2)}
                      </pre>
                    </div>
                  );
                })}
              </div>
            )
        }
      </div>
    </div>
  );
}
